<template>
  <div class="createOrEditRoot">
    <div class="resourceFormPage divContainer configModule">
      <div v-if="loading" v-loading="loading" class="fullContainer" />
      <div v-else class="resourceFormPage__layout">
        <el-form
          ref="ruleForm"
          label-position="top"
          size="small"
          class="resourceFormPage__form"
          :model="ruleForm"
          :rules="rules"
          hide-required-asterisk
          @submit.native.prevent
        >
          <div class="resourceFormPage__headerDock">
            <header class="resourceFormPage__actionBar">
              <div class="resourceFormPage__lead">
                <h1 class="resourceFormPage__pageTitle">
                  {{ isCreate ? '新建远程配置' : '编辑远程配置' }}
                </h1>
                <span
                  v-if="!isCreate"
                  class="resourceFormPage__typeReadonly"
                  :class="ruleForm.status === 1 ? 'configFormPage__statusPill--on' : 'configFormPage__statusPill--off'"
                >
                  {{ ruleForm.status === 1 ? '已上线' : '已下线' }}
                </span>
              </div>
              <div class="resourceFormPage__actions">
                <button
                  v-if="!isCreate"
                  type="button"
                  class="resourceFormPage__btn"
                  :class="ruleForm.status === 0 ? 'resourceFormPage__btn--primary' : 'resourceFormPage__btn--ghost'"
                  v-check-role
                  @click="liveOrOff"
                >
                  {{ ruleForm.status === 0 ? '上线' : '下线' }}
                </button>
                <button
                  type="button"
                  class="resourceFormPage__btn resourceFormPage__btn--ghost"
                  @click="goBack"
                >
                  取消
                </button>
                <button
                  type="button"
                  class="resourceFormPage__btn resourceFormPage__btn--primary"
                  :disabled="buttonLoading"
                  @click="submitForm"
                >
                  {{ buttonLoading ? '保存中…' : '保存' }}
                </button>
              </div>
            </header>
          </div>

          <main class="resourceFormPage__main main configFormPage__main">
            <el-card class="card linkFormSection configFormPage__section" data-section-id="basic">
              <div slot="header" class="linkFormSection__header">
                <strong class="linkFormSection__title">基本信息</strong>
              </div>

              <div class="configFormPage__remoteLayout">
                <div class="configFormPage__remoteFields">
                  <el-form-item label="AppKey" prop="appKey">
                    <el-input v-model="ruleForm.appKey" placeholder="请输入 AppKey" clearable />
                  </el-form-item>
                  <el-form-item label="Name" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="请输入 Name" clearable />
                  </el-form-item>
                  <el-form-item label="Key" prop="key">
                    <el-input v-model="ruleForm.key" placeholder="请输入 Key" clearable />
                  </el-form-item>
                  <el-form-item label="Comment" prop="comment">
                    <el-input
                      v-model="ruleForm.comment"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入 Comment"
                    />
                  </el-form-item>
                  <el-form-item label="Version" prop="version">
                    <el-input
                      v-model.number="ruleForm.version"
                      type="number"
                      placeholder="版本号"
                    />
                  </el-form-item>
                </div>

                <div class="configFormPage__jsonEditor">
                  <div class="configFormPage__jsonEditorHead">
                    <div>
                      <div class="configFormPage__jsonEditorTitle">Content JSON</div>
                      <div class="configFormPage__jsonEditorHint">
                        配置下发内容，保存前请确认 JSON 语法正确
                      </div>
                    </div>
                  </div>
                  <el-form-item prop="content" class="configFormPage__field--wide">
                    <div class="configFormPage__remoteJsonEditor">
                      <vue-json-editor
                        v-model="ruleForm.content"
                        :show-btns="false"
                        mode="code"
                        @json-change="onJsonChange"
                        @json-save="onJsonSave"
                        @has-error="onError"
                      />
                    </div>
                  </el-form-item>
                </div>
              </div>
            </el-card>
          </main>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  updateRemoteConfigById,
  getRemoteConfigById,
  createRemoteConfig,
  updateRemoteConfigStatus,
} from '../../../api/remoteConfig'
import VueJsonEditor from 'vue-json-editor'

export default {
  name: 'RemoteConfigCreateOrEdit',
  components: { VueJsonEditor },
  data() {
    return {
      isCreate: true,
      ruleForm: {
        appKey: '',
        name: '',
        key: '',
        comment: '',
        version: 1,
        content: {},
        status: 0,
      },
      hasJsonFlag: true,
      loading: false,
      buttonLoading: false,
      rules: {
        appKey: [{ required: true, message: 'appKey不能为空', trigger: 'blur' }],
        name: [{ required: true, message: 'name不能为空', trigger: 'blur' }],
        key: [{ required: true, message: 'key不能为空', trigger: 'blur' }],
        comment: [{ required: true, message: 'comment不能为空', trigger: 'blur' }],
        version: [{ required: true, message: 'version不能为空', trigger: 'blur' }],
        content: [{ required: true, message: 'content不能为空', trigger: 'blur' }],
      },
    }
  },
  created() {
    this.isCreate = this.$route.path.indexOf('edit') === -1
    if (!this.isCreate) {
      this.getData()
    }
  },
  methods: {
    checkJson() {
      if (this.hasJsonFlag === false) {
        this.$message.error('json验证失败')
        return false
      }
      return true
    },
    onJsonChange(value) {
      this.onJsonSave(value)
    },
    onJsonSave(value) {
      this.ruleForm.content = value
      this.hasJsonFlag = true
    },
    onError() {
      this.hasJsonFlag = false
    },
    getData() {
      this.loading = true
      getRemoteConfigById({ id: this.$route.params.id })
        .then((res) => {
          if (res.success) {
            this.ruleForm = res.data
          }
        })
        .catch((err) => {
          this.$message.error(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    liveOrOff() {
      this.$confirm(
        `是否确认将状态改成：${this.ruleForm.status === 0 ? '上线' : '下线'}`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          const status = this.ruleForm.status === 0 ? 1 : 0
          updateRemoteConfigStatus({ id: this.$route.params.id, status }).then((res) => {
            if (res.success) {
              this.$message.success('修改成功')
              this.$router.push('/config/remoteConfig/list')
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消修改')
        })
    },
    submitForm() {
      if (!this.checkJson()) return
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          this.$message.error('你还有参数没有填完整')
          return false
        }
        this.buttonLoading = true
        const request = this.isCreate
          ? createRemoteConfig(this.ruleForm)
          : updateRemoteConfigById(this.ruleForm)
        request
          .then((res) => {
            if (res.success) {
              this.$message.success(this.isCreate ? '新增成功!' : '编辑成功!')
              this.$router.push('/config/remoteConfig/list')
            }
          })
          .catch((err) => {
            this.$message.error(err)
          })
          .finally(() => {
            this.buttonLoading = false
          })
      })
    },
    goBack() {
      this.$router.push('/config/remoteConfig/list')
    },
  },
}
</script>

<style scoped>
.createOrEditRoot,
.fullContainer {
  height: 100%;
}

.resourceFormPage__form {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
</style>

<style>
.configModule.divContainer {
  min-height: 100%;
  background: var(--link-canvas);
}

.configModule .main {
  background: transparent;
}

.configFormPage__statusPill--on {
  color: #0369a1;
  background: rgba(224, 242, 254, 0.95);
  border-color: #bae6fd;
}

.configFormPage__statusPill--off {
  color: var(--link-ink-secondary);
}
</style>
